import React from 'react'

import { Col, Container, Row } from '@/atoms/Grid'
import { Spacer, ArchiveSidebar } from '@/organisms'
import Card from '@/molecules/Card'

import * as S from './styles'

const BlogList = ({ sidebar, posts }) => {
  return (
    <S.BlogList>
      <Container>
        <Row>
          <Col
            xs={12}
            md={4}
          >
            <ArchiveSidebar
              {...sidebar}
              entity='blog'
            />
          </Col>
          <Col
            xs={12}
            md={8}
          >
            <Row>
              {posts.map((post, i) => (
                <Col
                  key={`blogPost-${i}`}
                  xs={12}
                  sm={6}
                  md={4}
                >
                  <Card
                    data={post}
                    type='postFull'
                  />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
        <Spacer
          size='md'
          separator
        />
      </Container>
    </S.BlogList>
  )
}

export default BlogList
